import styled from 'styled-components';

export const PageWrapper = styled.div`
    width: 100%;
    min-height: 80vh;
    padding: 40px 20px 60px;

    @media (max-width: 768px) {
        padding: 24px 16px 40px;
    }
`;

export const PageHeader = styled.div`
    text-align: center;
    max-width: 800px;
    margin: 0 auto 40px;

    @media (max-width: 768px) {
        margin-bottom: 28px;
    }
`;

export const PageTitle = styled.h1`
    color: var(--white-color);
    font-size: 2.2rem;
    font-weight: 800;
    line-height: 1.2;
    margin: 0 0 12px 0;
    text-wrap: balance;

    @media (max-width: 768px) {
        font-size: 1.6rem;
    }
`;

export const PageSubtitle = styled.p`
    color: rgba(255, 255, 255, 0.65);
    font-size: 1.1rem;
    line-height: 1.5;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 0.95rem;
    }
`;

export const ModeContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 28px;
    max-width: 1000px;
    margin: 0 auto;
    flex-wrap: wrap;

    @media (min-width: 900px) {
        flex-wrap: nowrap;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }
`;

export const ModeCard = styled.div`
    background: ${props => props.primary
        ? 'linear-gradient(145deg, rgba(255, 153, 0, 0.12), rgba(255, 153, 0, 0.03))'
        : 'linear-gradient(145deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02))'};
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1.5px solid ${props => props.primary ? 'rgba(255, 153, 0, 0.55)' : 'rgba(255, 255, 255, 0.1)'};
    border-radius: 20px;
    padding: 36px 30px;
    flex: 1;
    max-width: 460px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    position: relative;
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
    box-shadow: ${props => props.primary
        ? '0 10px 40px rgba(255, 153, 0, 0.18)'
        : '0 10px 30px rgba(0, 0, 0, 0.3)'};

    &:hover {
        transform: translateY(-6px);
        border-color: ${props => props.primary ? 'rgba(255, 153, 0, 0.8)' : 'rgba(255, 255, 255, 0.2)'};
        box-shadow: ${props => props.primary
            ? '0 20px 50px rgba(255, 153, 0, 0.3)'
            : '0 20px 40px rgba(0, 0, 0, 0.4)'};
    }

    @media (max-width: 768px) {
        padding: 28px 22px;
        max-width: 100%;
    }
`;

export const PrimaryBadge = styled.div`
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--primary-color);
    color: white;
    padding: 5px 16px;
    border-radius: 20px;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 1px;
    box-shadow: 0 4px 15px rgba(255, 153, 0, 0.4);
`;

export const BonusBadge = styled.div`
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.8);
    padding: 5px 14px;
    border-radius: 20px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.5px;
`;

export const ModeIcon = styled.div`
    font-size: 3.2rem;
    margin: 8px 0 16px 0;
    line-height: 1;
`;

export const ModeTitle = styled.h2`
    color: var(--white-color);
    font-size: 1.6rem;
    font-weight: 800;
    margin: 0 0 12px 0;
    line-height: 1.2;
    text-wrap: balance;

    @media (max-width: 768px) {
        font-size: 1.35rem;
    }
`;

export const ModeDescription = styled.p`
    color: rgba(255, 255, 255, 0.75);
    font-size: 1rem;
    line-height: 1.5;
    margin: 0 0 22px 0;
`;

export const ModeFeatures = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0 0 28px 0;
    text-align: left;

    li {
        position: relative;
        padding: 7px 0 7px 26px;
        font-size: 0.92rem;
        color: rgba(255, 255, 255, 0.65);
        line-height: 1.4;

        &::before {
            content: "✓";
            position: absolute;
            left: 0;
            top: 7px;
            color: var(--primary-color);
            font-weight: 800;
            font-size: 1rem;
        }
    }
`;

export const ModeCTA = styled.div`
    color: ${props => props.primary ? 'var(--primary-color)' : 'rgba(255, 255, 255, 0.7)'};
    font-size: 1rem;
    font-weight: 700;
    margin-top: auto;
    padding-top: 8px;
    transition: transform 0.2s ease;

    ${ModeCard}:hover & {
        transform: translateX(4px);
    }
`;

export const SecondaryActions = styled.div`
    margin: 36px auto 0;
    display: flex;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        margin-top: 24px;
    }
`;

export const SecondaryLink = styled.button`
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.75);
    padding: 10px 22px;
    border-radius: 24px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    &:hover {
        background: rgba(255, 153, 0, 0.1);
        border-color: rgba(255, 153, 0, 0.45);
        color: var(--white-color);
    }

    &:focus-visible {
        outline: 2px solid var(--primary-color);
        outline-offset: 2px;
    }
`;
